var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 18.75H16.125V16.5H18.375V18.75ZM22.125 16.5H19.875V18.75H22.125V16.5ZM18.375 20.25H16.125V22.5H18.375V20.25ZM22.125 20.25H19.875V22.5H22.125V20.25ZM15.375 6H9.375V7.5H15.375V6ZM13.125 21H4.875V18H6.375V16.5H4.875V12.75H6.375V11.25H4.875V7.5H6.375V6H4.875V3H18.375V14.25H19.875V3C19.875 2.175 19.2 1.5 18.375 1.5H4.875C4.05 1.5 3.375 2.175 3.375 3V6H1.875V7.5H3.375V11.25H1.875V12.75H3.375V16.5H1.875V18H3.375V21C3.375 21.825 4.05 22.5 4.875 22.5H13.125V21ZM15.375 11.25H9.375V12.75H15.375V11.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotebook);
export default __webpack_public_path__ + "static/media/ic-notebook.a97ead3deb766d929f84f3b4e1d9c9ef.svg";
export { ForwardRef as ReactComponent };